export default __webpack_public_path__ + "static/media/mytutku6.de3c31dc.jpg";